export const HOME_OVERVIEW_VIDEO = {
  videoId: "3WItNh5pWio",
  title: "One Chart, Three People: The Structura System in 80 Seconds",
  description: "The trader asks whether a chart is worth attention today, the advisor what to tell a client on Monday, the portfolio manager which names changed state. Structura answers all three on the same chart.",
  thumbnailUrl: "https://i.ytimg.com/vi/3WItNh5pWio/maxresdefault.jpg",
  fallbackThumbnailUrl: "https://i.ytimg.com/vi/3WItNh5pWio/hqdefault.jpg",
  playLabel: "Play: One Chart, Three People - the Structura system in 80 seconds",
  playlistUrl: "https://www.youtube.com/playlist?list=PLDIUX_hWzSYU",
  embedUrl: "https://www.youtube-nocookie.com/embed/3WItNh5pWio",
};

export const HOME_OVERVIEW_VIDEO_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  name: HOME_OVERVIEW_VIDEO.title,
  description: HOME_OVERVIEW_VIDEO.description,
  thumbnailUrl: HOME_OVERVIEW_VIDEO.thumbnailUrl,
  uploadDate: "2026-10-24",
  duration: "PT1M22S",
  embedUrl: HOME_OVERVIEW_VIDEO.embedUrl,
  contentUrl: "https://www.youtube.com/watch?v=3WItNh5pWio",
  publisher: {
    "@type": "Organization",
    name: "Structura",
    url: "https://structuramarkets.com",
  },
};
